/**
 * Extend Marb namespace
 */
try {
	Marb.extend({
		CashAdvance: (function() {
			
			var loadCashAdvances = function (params, callback){					
				var jobId = params.jobId;
				var afterRequest = params.afterRequest;
				var hasSelectedQuote = params.hasSelectedQuote;
				var acceptsCashAdvance = params.acceptsCashAdvance;
				var acceptCreditCard = params.acceptCreditCard;
				var container = params.container;
				callback = callback || function(){};
				$.ajax('/secure/order/get-cash-advances-by-job',{
					method : "GET",
					dataType: 'json',					
					data: {"jobId": jobId},					
					cache : false,
					success: function(data){
						if(data.success){
							cashAdvances = data.data.cashAdvances;
							if(cashAdvances != undefined && cashAdvances.length > 0){
								$(container).show();
								$(".job-cash-advance-btns").addClass("job-cash-advance-all-btns");
								if(afterRequest != undefined){									
									afterRequest();
								}
							} else if (!(cashAdvances != undefined && cashAdvances.length > 0) 
									&& ! (hasSelectedQuote && acceptsCashAdvance && acceptCreditCard)) {
								$(".job-cash-advance-btns").hide();
							}							
							callback(cashAdvances);
						}						
					}
				});
			};
			
			
			var doPaymentCashAdvance = function (docTypes, quoteId){				
				var contentHtml =  '<div id="cash-advance">' +					
					'<div class="field-container">' +
						'<label id="label-for-amount" class="label-cash-advance text-xl">'+$.i18n.prop('p.customer.cashadvance.amount')+'</label>' +
						'</br>'+
						'<span id="label-coin" class="text-xl">'+$.i18n.prop('p.generic.currencySymbol')+'</span>  <input id="amount" type="text" value=""  maxlength="9" size="9"/> <span id="decimal-numbers" class="text-m">' + $.i18n.prop('p.generic.decimalSeparator') + "00 </span>" +
					'</div>' +
					'</br>' +
					'<div class="field-container invoice">' +
						'<label id="label-for-docNumber" class="label-cash-advance text-xl" style="margin-top:10px;">'+$.i18n.prop('p.customer.cashadvance.doc')+'</label>' +
						'</br>'+
						'<select id="docType" style="margin-right:10px;" name="docType">';
				var docTypesList = docTypes.split(",");
				$.each(docTypesList, function( key, docType ) {	
					docType = docType.replace(/[[/\]]/, "");
					contentHtml += '<option value="'+docType+'">'+docType+'</option>';				
				});
				contentHtml += 	'</select>'+
									'<input id="docNumber" value="" type="text" maxlength="9" size="9"/>' +
							'</div>' +
						'</div>';
				
				Marb.Components.Confirm.openSimple({
					title : $.i18n.prop('p.company.user.doPayment'),
					bodyHtml : contentHtml,
					acceptText : $.i18n.prop('p.popup.accept.btn.continue'),
					accept : function(data) {
						var docType = $("#cash-advance #docType option:selected").text();
						var docNumber = $("#cash-advance #docNumber").val();
						var verified = true;
						
						if (docNumber == ""){
							$("#cash-advance #docNumber").addClass("error");
							verified = false;
						} else {
							$("#cash-advance #docNumber").removeClass("error");
						} 							
						
						
						var amountInCents = $("#cash-advance #amount").val() * 100;
						if (amountInCents == 0){
							$("#cash-advance #amount").addClass("error");
							verified = false;
						} else {
							$("#cash-advance #amount").removeClass("error");
						} 
						
						if (verified){
							$.ajax('/secure/order/cash-advance',{
								method : "POST",
								dataType: 'json',
								data: {"quoteId": quoteId, "docType" : docType, "docNumber" : docNumber, "amountInCents" : amountInCents},
								success: function(data){
									if(data.success){
										document.location.href = '/secure/order/review/'+data.data.orderId;
									}else{
										Marb.Page.Toast.error({
											text: $.i18n.prop('p.toast.create.cashadvance.error')
										});
									}
								},
								error: function(){
									Marb.Page.Toast.error({
										text: $.i18n.prop('p.toast.create.cashadvance.error')
									});
								}
							});
						} else {
							var preventClose = true;
							return preventClose;
						}
					},
					cancel : function (){
						$(".acceptCreditCard").attr('checked', false);
					}
				});
			
				 $("#cash-advance #amount").keydown(function (e) {
				        // Allow: backspace and delete
				        if ($.inArray(e.keyCode, [8, 9, 46]) !== -1 ||
				             // Allow: Ctrl+A
				            (e.keyCode == 65 && e.ctrlKey === true) || 
				             // Allow: home, end, left, right, down, up
				            (e.keyCode >= 35 && e.keyCode <= 40)) {
				                 // let it happen, don't do anything
				                 return;
				        }
				        // Ensure that it is a number and stop the keypress
				        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				            e.preventDefault();
				        }
				    });
				 
				 $('#cash-advance #amount').on("contextmenu", function(evt) {evt.preventDefault();});
			}
			
			
			var popUpCashAdvances = function (cashAdvances){
				var contentHtml = '<div id="cash-advances"><table>';		
				contentHtml += '<thead>'
					contentHtml += '<tr>'
						contentHtml += '<td class="header">'+$.i18n.prop('p.popup.user.cashadvance.date')+'</td>'
						contentHtml += '<td class="header">'+$.i18n.prop('p.popup.user.cashadvance.amount')+'</td>'
						contentHtml += '<td class="header">'+$.i18n.prop('p.popup.user.cashadvance.actions')+'</td>'
					contentHtml += '</tr>'
				contentHtml += '</thead>'
				contentHtml += '<tbody>'		
				
				$.each(cashAdvances, function( key, ca ) {
					var date = new Date(ca.cashAdvanceDate);
					var month = date.getMonth() + 1;
					var dateStr = date.getDate() +"/"+month+"/"+date.getFullYear()
					contentHtml += '<tr id="cashadvance-'+ca.id+'">';
					contentHtml += '<td class="value"><span class="date text-s">'+dateStr+'</span></td>';
					contentHtml += '<td class="value"><span class="price text-s" id="amount"'+ca.id+'">'+Marb.Commons.Utils.formatCurrency(ca.totalInCents/100)+'</span></td>';
					if(!ca.payed){
						contentHtml += '<td class="value">';
							contentHtml += '<a class="deleteCashAdvance link underline text-xs" data-caId="'+ca.id+'">'+$.i18n.prop('p.company.user.cashadvance.delete')+'</a>';
							contentHtml += '<a class="payCashAdvance btn btn-mini btn-green text-s-fixed" data-orderId="'+ca.orderId+'">'+$.i18n.prop('p.company.user.cashadvance.pay')+'</a>';
						contentHtml += '</td>';
					} else {
						contentHtml += '<td class="value">';
							contentHtml += '<a class="seeCashAdvanceOrder link underline text-xs" data-orderId="'+ca.orderId+'">'+$.i18n.prop('p.company.user.cashadvance.see.order')+'</a>';
						contentHtml += '</td>';
					}
					contentHtml += '</tr>';
				});
				contentHtml += '</div></tbody></table>';
	
				Marb.Components.Confirm.openSimple({
					showCancel : false,
					showAccept : false,
					title : $.i18n.prop('p.company.user.yourPayments'),
					bodyHtml : contentHtml
				});				
	
				$(".seeCashAdvanceOrder").click(seeCashAdvanceOrder);				
				$(".payCashAdvance").click(payCashAdvance);
				$(".deleteCashAdvance").click(deleteCashAdvance);				
			};
			
			var payCashAdvance = function(){
				document.location.href = '/secure/order/review/'+$(this).data("orderid");
			};
			
			var seeCashAdvanceOrder = function(){
				document.location.href = '/secure/order/finished/'+$(this).data("orderid");
			};
			
			var deleteCashAdvance = function(){
				$.ajax('/secure/order/cancel-cash-advance',{
					method : "POST",
					dataType: 'json',
					data: {"id": $(this).data("caid")},
					success: function(data){
						if(data.success){
							$("#cashadvance-"+data.data.cashid).fadeOut(300, function() { 
								$("#cashadvance-"+data.data.cashid).remove();
								$.each(cashAdvances, function( key, ca ) {
									if (ca.id == data.data.cashid){
										cashAdvances.splice(key,1);
										Marb.Page.Toast.success({
											text: $.i18n.prop('p.toast.delete.cashadvance.success')
										});
										
										if(cashAdvances.length == 0){
											$( ".simplemodal-close" ).trigger( "click" );
											$("#job-cash-advances").remove();
											$(".job-cash-advance-btns").removeClass("job-cash-advance-all-btns");
										}
										return;
									}
								});
								
							});
							
						}else{
							Marb.Page.Toast.error({
								text: $.i18n.prop('p.toast.delete.cashadvance.error')
							});
						}
					},
					error: function(){
						Marb.Page.Toast.error({
							text: $.i18n.prop('p.toast.delete.cashadvance.error')
						});
					}
				});
				
			};
			
			return {
				loadCashAdvances : loadCashAdvances,
				doPaymentCashAdvance : doPaymentCashAdvance,
				popUpCashAdvances : popUpCashAdvances
			};
		})()
	});

}
catch (e) {
	debug.error("Marb namespace not present", e);
}
